import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=0f69c73b&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/contact-us.scss?vue&type=style&index=0&id=0f69c73b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f69c73b",
  null
  
)

export default component.exports